PJQ.models.dailyReports.Attachment = PJQ.models.files.File.extend({
    idAttribute: 'attachmentId',
    endpoint: function () {
        return PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'dailyReports',
                value: this.get('dailyReportId')
            },
            {
                endpoint: 'attachments',
                value: this.id
            }
        ]);
    }
});

PJQ.collections.dailyReports.Attachments = PJQ.collections.files.Files.extend({
    model: PJQ.models.dailyReports.Attachment
});